import ReadMoreReadLess from '@global/ReadMoreReadLess'
import * as S from './SuburbContent.styled'

const SuburbContent = ({ content, lines = 10 }) => {
  return (
    <S.SuburbContent>
      <ReadMoreReadLess
        style={{ marginBottom: '0' }}
        content={content}
        lines={lines}
      />
    </S.SuburbContent>
  )
}

export default SuburbContent
